import styled from 'styled-components/macro';
import {
  darkerGray,
  gray,
  hardWhite,
  newBorder,
  newRed,
} from '../../config/colors';

export const TextAreaWrapper = styled.div`
  position: relative;
  width: 100%;

  textarea:focus + .custom-placeholder {
    display: none;
  }
`;

export const StyledTextArea = styled.textarea`
  font-size: 16px;
  outline: none;
  border: 1px solid ${newBorder};
  color: ${darkerGray};
  padding: 8px 12px;
  width: 100%;
  border-radius: 4px;
  min-height: 74px;
  resize: none;
  font-family: 'nunitosans', 'Roboto', sans-serif;
  background-clip: padding-box;
  position: relative;

  :focus {
    background-color: ${hardWhite};
  }

  ::placeholder {
    color: ${gray};
  }

  &:disabled {
    background-color: white;
  }

  ${({ isMandatory }) =>
    isMandatory
      ? `

    padding: 5px 5px 5px 0px;
    
    ::placeholder {
      color: transparent;
    }

    `
      : null};
`;

export const CustomPlaceholder = styled.div.attrs({
  className: 'custom-placeholder',
})`
  position: absolute;
  top: 5px;
  left: 0;
  color: ${darkerGray};
  font-size: 16px;
  pointer-events: none;
  font-weight: 600;
})`;

export const Asterisk = styled.span`
  color: ${newRed};
`;
